import { c as _c } from "react/compiler-runtime";
import { ExpandableText } from "@/components/ui/expandable-text";
import { cx } from "@/lib/tailwind-utils";
interface ServiceDescriptionProps {
  description: string;
  standalone?: boolean;
  expandOnHover?: boolean;
  /** Two lines with a See more toggle, so a long add-on list stays scannable. */
  collapsible?: boolean;
  className?: string;
}
export const ServiceDescription = t0 => {
  const $ = _c(6);
  const {
    description,
    standalone: t1,
    expandOnHover,
    collapsible: t2,
    className
  } = t0;
  const standalone = t1 === undefined ? false : t1;
  const collapsible = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== className || $[1] !== collapsible || $[2] !== description || $[3] !== expandOnHover || $[4] !== standalone) {
    t3 = collapsible ? <ExpandableText text={description} className={className} textClassName="text-body leading-relaxed text-foreground-secondary/90" stopPropagation={true} /> : <p className={cx("whitespace-pre-line text-body leading-relaxed text-foreground-secondary/90", standalone ? "line-clamp-6" : "line-clamp-2", expandOnHover && "group-hover:line-clamp-none transition-all duration-300", className)}>{description}</p>;
    $[0] = className;
    $[1] = collapsible;
    $[2] = description;
    $[3] = expandOnHover;
    $[4] = standalone;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};